// Remove accents + lowercase + trim
export function normalizeTextForSearch(str: string | undefined): string {
    return stripAccents(str ?? '').toLowerCase().trim();
}

export function stripAccents(str: string): string {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
